/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Encrypt_AcInputs */

const en_pc_cmp_r_encrypt_ac = /** @type {(inputs: Pc_Cmp_R_Encrypt_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, plus certificate security`)
};

const zh_pc_cmp_r_encrypt_ac = /** @type {(inputs: Pc_Cmp_R_Encrypt_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持，并提供证书加密`)
};

/**
* | output |
* | --- |
* | "Yes, plus certificate security" |
*
* @param {Pc_Cmp_R_Encrypt_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_encrypt_ac = /** @type {((inputs?: Pc_Cmp_R_Encrypt_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Encrypt_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_encrypt_ac(inputs)
	return zh_pc_cmp_r_encrypt_ac(inputs)
});
export { pc_cmp_r_encrypt_ac as "pc.cmp.r.encrypt.ac" }